import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import useApplication from '../../resources/applications/read';
import useApplicationUpdate from '../../resources/applications/update';
import useCreateRecurringPayment from '../../resources/recurringPayments/create';

const useForm = () => {
  const { data: application } = useApplication();
  const {
    trigger: updateApplication, isMutating: isLoadingApplication,
  } = useApplicationUpdate();

  const onSubmit = (form) => ({
    recurring_payment: {
      amount: 0,
      amount_extra: 0,
      recurrable_type: 'BankAccount',
      application_id: application.id,
      recurrable_id: form.selectedBankAccountId,
    },
  });

  const onSuccess = async () => {
    updateApplication({
      application: { recurring_payment_completed: true },
    });
  };

  const {
    isSubmitting,
    handleSubmit,
    control,
    formState,
    error,
  } = useSWRMutationForm({
    useMutation: () => useCreateRecurringPayment({ onSuccess }),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
  });

  const isLoading = isSubmitting || isLoadingApplication;

  return {
    isLoading,
    handleSubmit,
    control,
    formState,
    error,
  };
};

export default useForm;
